import { baseApi } from "@/redux/api/baseApi";
import { tagTypes } from "@/redux/tagTypes";

export const appointmentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createAppointment: builder.mutation({
      query: (data) => ({
        url: "/public-appointments",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.appointment],
    }),
    getAppointmentById: builder.query({
      query: (id) => ({
        url: `/public-appointments/${id}`,
        method: "GET",
      }),
      providesTags: [tagTypes.appointment],
    }),
    getAllCounsellor: builder.query({
      query: ({
        service_id,
        division_id,
      }: { service_id?: string; division_id?: string } = {}) => ({
        url: `/public-users/counselors`,
        method: "GET",
        params: {
          ...(service_id && { service_id }),
          ...(division_id && { division_id }),
        },
      }),
    }),
    checkAvailability: builder.query({
      query: ({ datetime, timezone }: { datetime: string; timezone: string }) => ({
        url: `/public-calenders/check-availability?datetime=${encodeURIComponent(datetime)}&timezone=${encodeURIComponent(timezone)}`,
        method: "GET",
      }),
    }),
    getAppointmentByToken: builder.query({
      query: (token) => ({
        url: `/public-appointments/by-token?token=${token}`,
        method: "GET",
      }),
      providesTags: [tagTypes.appointment],
    }),
  }),
});

export const {
  useCreateAppointmentMutation,
  useGetAppointmentByIdQuery,
  useGetAllCounsellorQuery,
  useCheckAvailabilityQuery,
  useGetAppointmentByTokenQuery,
} = appointmentApi;
